import { createAction } from '@reduxjs/toolkit';
import { FileModel } from './filesSlice';
import { Page } from '../pages/pagesSlice';
import { nanoid } from 'nanoid';
import { FileType } from 'helpers';

export const addFileAction = createAction(
    'files/addFile',
    (type: FileType, id: string, fileName: string, fileSize: number, numOfPages: number, refId?: string | number) => {
        const file: FileModel = {
            id,
            refId,
            fileName,
            fileSize,
            pagesIds: []
        };

        const pages: Partial<Page>[] = [];
        for (let i = 0; i < numOfPages; ++i) {
            const page: Partial<Page> = {
                type,
                id: nanoid(),
                pageNr: i + 1,
                sourceFileId: id,
                sourceFileRefId: refId
            };

            file.pagesIds.push(page.id!);
            pages.push(page);
        }

        return {
            payload: { file, pages }
        };
    }
);

export const removeFileAction = createAction('removeFile');
